import { COMMERCIAL_PERIODS_SET_LIST } from "../types";

import { createReducer } from "./functions";

const initialState = {
  commercialList: [],
  page: 0,
  pages: 0,
  pageSize: 10,
  hasNext: true,
  currentFilters: {},
  sort: { active: -1, updated_at: -1, created_at: -1, _id: -1 }
};

const setCommercialList = {
  [COMMERCIAL_PERIODS_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages) {
      hasNext = false;
    }

    return {
      ...state,
      commercialList: action.payload.docs,
      page,
      pages,
      hasNext
    };
  }
};

const commercialReducer = createReducer(initialState, {
  ...setCommercialList
});

export default commercialReducer;



// WEBPACK FOOTER //
// src/redux/reducers/commercialReducer.js